import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import "./interview.css";
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { Modal } from 'react-bootstrap';
import { apiService } from '../../../../services/apiService';
import { toast } from 'react-toastify';

function InterviewsSlot() {
    const { id, opid } = useParams();
    const navigate = useNavigate();
    const [time, setTime] = useState("");
    const [value, setValue] = useState(dayjs());
    const [selectedTime, setSelectedTime] = useState(null);
    const [termsConditions, setTermsConditions] = useState(false);
    const handleCloseTermsCondition = () => setTermsConditions(false);

    const [interviewData, setInterviewData] = useState([]);

    const fetchPermissionData = useCallback(async (params = {}) => {
        // setLoading(true);
        try {
            // const defaultParams = {
            //     page: 1,
            // };
            // const finalParams = { ...defaultParams, ...params };
            const response = await apiService.getRequest(`/interview-services/${id}`);
            if(response && response.success){
                setInterviewData(response.data || []);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching group data:', error);
        }finally {
            // setLoading(false);
        }
    }, [id]);
    useEffect(() => {
        fetchPermissionData();
    }, [fetchPermissionData]);

    useEffect(() => {
        const updateTime = () => {
        const now = new Date();
        const formatted = new Intl.DateTimeFormat("en-US", {
            timeZone: "America/Chicago",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        }).format(now);

        setTime(formatted);
        };

        updateTime();
        const interval = setInterval(updateTime, 1000);

        return () => clearInterval(interval);
    }, []);
    
    const manualDisabledTimes = [
        '2:00 PM', '2:05 PM', '2:10 PM',  // Lunch break
        '5:00 PM', '5:30 PM',              // Meeting times
        '9:00 PM', '9:30 PM'               // Already booked
    ];

    // const [selectedTime, setSelectedTime] = useState(null);
  
    // Convert value prop to Date object
    // Accepts: Date object, dayjs object, or string in format "MM / DD / YYYY"
    const parseDateFromProp = (dateValue) => {
        if (!dateValue) return new Date();
        
        // If it's already a Date object
        if (dateValue instanceof Date) {
        return dateValue;
        }
        
        // If it's a dayjs object (has format method)
        if (dateValue && typeof dateValue === 'object' && typeof dateValue.format === 'function') {
        return dateValue.toDate();
        }
        
        // If it's a string in format "MM / DD / YYYY"
        if (typeof dateValue === 'string') {
        // Remove spaces and split by "/"
        const cleanDate = dateValue.replace(/\s/g, '');
        const [month, day, year] = cleanDate.split('/');
        
        // Create date object (month is 0-indexed in JS)
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        }
        
        // Fallback to current date
        return new Date();
    };
    
    const dateObj = parseDateFromProp(value);
    
    // Format date for display
    // const formatDateDisplay = () => {
    //     if (!value) return '';
        
    //     // If it's a dayjs object
    //     if (value && typeof value === 'object' && typeof value.format === 'function') {
    //     return value.format('MM / DD / YYYY');
    //     }
        
    //     // If it's already a formatted string
    //     if (typeof value === 'string') {
    //     return value;
    //     }
        
    //     // If it's a Date object
    //     if (value instanceof Date) {
    //     const month = String(value.getMonth() + 1).padStart(2, '0');
    //     const day = String(value.getDate()).padStart(2, '0');
    //     const year = value.getFullYear();
    //     return `${month} / ${day} / ${year}`;
    //     }
        
    //     return '';
    // };
    
    // Check if selected date is today
    const isToday = () => {
        const today = new Date();
        return today.toDateString() === dateObj.toDateString();
    };
    
    // Calculate disabled times based on current time + 4 hours (only for today)
    const getDisabledTimes = () => {
        const disabled = [...manualDisabledTimes]; // Start with manual disabled times
        
        // If selected date is not today, only return manual disabled times
        if (!isToday()) {
        return disabled;
        }
        
        const now = new Date();
        const fourHoursLater = new Date(now.getTime() + 4 * 60 * 60 * 1000);
        
        const allSlots = generateTimeSlots();
        
        allSlots.forEach(timeSlot => {
        const slotDate = parseTimeSlot(timeSlot);
        // Disable if time is in the past or within 4 hours from now
        if (slotDate <= fourHoursLater && !disabled.includes(timeSlot)) {
            disabled.push(timeSlot);
        }
        });
        
        return disabled;
    };
    
    // Parse time slot string to Date object for comparison
    const parseTimeSlot = (timeString) => {
        const [time, period] = timeString.split(' ');
        const [hourStr, minuteStr] = time.split(':');
        let hour = parseInt(hourStr);
        const minute = parseInt(minuteStr);
        
        if (period === 'PM' && hour !== 12) hour += 12;
        if (period === 'AM' && hour === 12) hour = 0;
        
        const date = new Date();
        date.setHours(hour, minute, 0, 0);
        
        return date;
    };
    
    // Generate all time slots for 24 hours
    const generateTimeSlots = () => {
        const slots = [];
        for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 5) {
            const period = hour >= 12 ? 'PM' : 'AM';
            const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
            const timeString = `${displayHour}:${minute.toString().padStart(2, '0')} ${period}`;
            slots.push(timeString);
        }
        }
        return slots;
    };
    
    const timeSlots = generateTimeSlots();
    const disabledTimes = getDisabledTimes();
    
    // Group times by hour
    const groupedSlots = timeSlots.reduce((acc, time) => {
        const hour = time.split(':')[0] + ' ' + time.split(' ')[1];
        if (!acc[hour]) acc[hour] = [];
        acc[hour].push(time);
        return acc;
    }, {});
    
    const getButtonStyle = (time) => {
        const isDisabled = disabledTimes.includes(time);
        const isSelected = selectedTime === time;
        
        if (isDisabled) {
        return 'disabled_timebtn';
        }
        if (isSelected) {
        return 'selected_timebtn text-white';
        }
        return 'bg-blue-100 text-blue-900 hover:bg-blue-200';
    };
    
    const handleTimeClick = (time) => {
        if (!disabledTimes.includes(time)) {
        setSelectedTime(time);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (!validateForm()) {
        //     setErrorMessage('Please fix the errors before proceeding.');
        //     return;
        // }
        // setSubmitloader(true);
        try {
            const formDataToSend = ({
                "interview_opportunity_id":opid,
                "interview_service_id":id,
                "start": selectedTime,
                "reserved_date":value,
                "success_url": `${window.location.origin}/catalogs/interviews-opportunity`, 
                "cancel_url": `${window.location.origin}/catalogs/interviews-slot/${id}/${opid}`,
            })

            // // Add file attachments
            // files.forEach((file) => {
            //     formDataToSend.append('attachment', file.file);
            // });

            // // Add other form fields
            // for (const key in formData) {
            //     if (formData[key] !== undefined && formData[key] !== null) {
            //         formDataToSend.append(key, formData[key]);
            //     }
            // }
            const response = await apiService.postRequest('reserved-interview', formDataToSend);

            // Check if the response indicates success
            if (response && response.success === true) {
                setTermsConditions(false);
                if(response && response.url){
                    window.location.href = response.url;
                }
                // setErrors({});
                // setErrorMessage('');
                // navigate("/catalogs/interviews-opportunity");
                toast(response.message || "Submitted Successfully !")
            } else {
                // setErrorMessage(response.message || "Failed. Please try again");
                // if (response.errors) {
                //     setErrors(response.errors);
                // }
            }
        } catch (error) {
            console.log("err",error);
        }finally {
            // setSubmitloader(false); // Stop loader
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                    <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Interviews Booking</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate(-1)}>Catalog</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> Interviews Booking</span>
                    </Grid>
                    <span className='fw-medium'>Our time: <b className='fw-bold'>{time} America/Chicago</b></span>
                </Grid>
                <Grid size={{md:12,xs:12}} container justifyContent="flex-end" alignItems="center" className="my-4">
                    <Grid size={{xs:12}} container className="mt-4 gap-md-4">
                        {/* {permissionstest && permissionstest.manage_case_submitter === true ? */}
                        <Grid size={{md:5,xs:12}} onClick={()=>navigate("/catalogs/interviews-booking")} container flexDirection="column" justifyContent="space-between" className="grid_interviewgrids mt-3">
                            <div className='d-flex flex-wrap justify-content-between align-items-center mb-3'>
                                <img src={require("../../../../assets/catalog/interview_icon.svg").default} alt=''/>
                                <div className='d-flex flex-wrap interview_hourset'>
                                    <span><FontAwesomeIcon icon={faClock} /> 
                                    {interviewData.duration}</span>
                                    <h5>${interviewData.amount}</h5>
                                    <h6 className='mt-3 fw-semibold w-100'>{interviewData.title}</h6>
                                </div>
                            </div>
                            <span>{interviewData.description}</span>
                        </Grid>
                    </Grid>
                    <Grid size={{xs:12}} container className="calendar_slots mt-5">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateCalendar minDate={dayjs()} value={value} onChange={(newValue) => setValue(newValue)} />
                        </LocalizationProvider>
                    </Grid>
                    <Grid size={{xs:12}} container className="mt-5">
                        <div className='d-flex flex-wrap justify-content-between align-items-center w-100'>
                            <button onClick={()=>{
                                if(dayjs().format('YYYY-MM-DD') !== dayjs(value).format('YYYY-MM-DD')){
                                    setValue(dayjs(value).subtract(1, 'day'))
                                }
                                }} className='registersendbtn1 my-0' ><FontAwesomeIcon icon={faChevronLeft} /> Prev Date</button>
                            <p className='my-0 fw-bold'>{dayjs(value).format('MM / DD / YYYY')}</p>
                            <button onClick={()=>{setValue(dayjs(value).add(1, 'day'))}} className='registersendbtn1 my-0'>Next Date <FontAwesomeIcon icon={faChevronRight} /></button>
                        </div>
                        <Grid size={{xs:12}} container className="mt-5 main_timeslot_scroll">
                            {Object.entries(groupedSlots).map(([hour, times]) => (
                                <div key={hour} className='d-flex flex-wrap w-100 align-items-start mb-5'>
                                    <div className='time_interviewslot'>
                                        {hour}
                                    </div>
                                    <div className='time_slotbtnsmain gap-3 d-flex flex-wrap'>
                                        {times.map((time) => (
                                            <button
                                            key={time}
                                            onClick={() => handleTimeClick(time)}
                                            disabled={disabledTimes.includes(time)}
                                            className={`
                                                px-4 py-2 rounded-lg font-medium transition-colors
                                                ${getButtonStyle(time)}
                                            `}
                                            >
                                            {time}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </Grid>
                        <Grid size={{xs:12}} container justifyContent="flex-end" className="gap-3">
                            <button className='registersendbtn1 mb-0' onClick={()=> setValue(dayjs())}>Reset</button>
                            <button className='registersendbtn2 mb-0' onClick={()=> setTermsConditions(true)}>Save</button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Modal
                show={termsConditions} 
                onHide={handleCloseTermsCondition}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    <h5 className='modal_pinkheader'>BenchTrack Consulting Service Terms and Conditions</h5>
                </Modal.Header>
                <Modal.Body>
                    <form className='d-flex flex-column roleback_mainmodal'>
                        <div className='w-100'>
                            <p>Agreement between User and <Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link></p>
                            <p>Welcome to <Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link>. The <Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link> website (the "Site") is comprised of various web pages operated by Tekpossible Consulting LLC ("Tekpossible"). <Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link> is offered to you conditioned on your acceptance without modification of the terms, conditions, and notices contained herein (the "Terms"). Your use of <Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link> constitutes your agreement to all such Terms. Please read these terms carefully, and keep a copy of them for your reference.</p>
                            <p><Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link> is a Learning Management Site.</p>
                            <p>The purpose of this website is to allow customers to schedule appointments with Service providers, and attend scheduled classes by instructors.</p>
                            <p>Electronic Communications</p>
                            <p>Visiting <Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link> or sending emails to Tekpossible constitutes electronic communications. You consent to receive electronic communications and you agree that all agreements, notices, disclosures and other communications that we provide to you electronically, via email and on the Site, satisfy any legal requirement that such communications be in writing.</p>
                            <p>Your Account</p>
                            <p>If you use this site, you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and you agree to accept responsibility for all activities that occur under your account or password. You may not assign or otherwise transfer your account to any other person or entity. You acknowledge that Tekpossible is not responsible for third party access to your account that results from theft or misappropriation of your account. Tekpossible and its associates reserve the right to refuse or cancel service, terminate accounts, or remove or edit content in our sole discretion.</p>
                            <p>Children Under Thirteen</p>
                            <p>Tekpossible does not knowingly collect, either online or offline, personal information from persons under the age of thirteen. If you are under 18, you may use <Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link> only with permission of a parent or guardian.</p>
                            <p>Links to Third Party Sites/Third Party Services</p>
                            <p><Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link> may contain links to other websites ("Linked Sites"). The Linked Sites are not under the control of Tekpossible and Tekpossible is not responsible for the contents of any Linked Site, including without limitation any link contained in a Linked Site, or any changes or updates to a Linked Site. Tekpossible is providing these links to you only as a convenience, and the inclusion of any link does not imply endorsement by Tekpossible of the site or any association with its operators.</p>
                            <p>Certain services made available via <Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link> are delivered by third party sites and organizations. By using any product, service or functionality originating from the <Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link> domain, you hereby acknowledge and consent that Tekpossible may share such information and data with any third party with whom Tekpossible has a contractual relationship to provide the requested product, service or functionality on behalf of <Link to="https://interviewmentor.simplybook.me/v2/" target='_blank'>https://interviewmentor.simplybook.me/v2/</Link> users and customers.</p>
                        </div>
                        <div className='d-flex justify-content-end'>
                            <button type='button' onClick={(e)=> handleSubmit(e)} className='registersendbtn2 mb-2 ' >
                                {/* {submitloader ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Submit'} */}
                                I Agree
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    </div>
  )
}

export default InterviewsSlot
